import { compose, hoistStatics, withHandlers, lifecycle, withProps} from 'recompose';
import { withRouter } from 'react-router-dom';
import Feedback from './Feedback';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/feedback.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';

const defaultFormData = {
  name: '',
  email: '',
  phone: '',
  company: '',
  industry: '',
  url: '',
  message: '',
  status: ModelService.ACTIVE,
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
    },
  }),
  withProps(props => ({
    title: props.t('Feedback') + fh.getTitleEnd(props),
    statusList: ModelService.getStatusOptions(props.t),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    onChangeMl: fh.onChangeFormDataMlElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Feedback, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/feedbacks/feedback/index.js